import React, { useContext} from "react";

import { store } from "./lib/store";
import CustomerInformationForm from "./library/components/CustomerInformationForm/CustomerInformationForm";
import SpinLoader from "./library/components/spinner/spinner";

import "antd/dist/antd.css";
import "./App.css";

function App() {
  const { state, dispatch } = useContext(store);
  // const [enabledDates, setEnabledDates] = useState([]);
  //TODO: pass proper format date
  const setServiceDays = (val) => {
    dispatch({
      type: "updateServiceDay",
      value: val,
      // limit: get_date_limit(val),
      limit: 100,
    });
  };

  const setServiceType = (val) => {
    dispatch({ type: "updateServiceType", value: val });
  };

  // useEffect(() => {
  //   // submit
  //   const data = new FormData();
  //   data.append("serviceType", state.serviceType);
  //   data.append("action", "expo_mnt_active_dates");

  //   axios
  //     .post(window.woocommerce_params.ajax_url, data)
  //     .then((res) => {
  //       if (res.data && res.data.message && res.data.message === "success") {
  //         console.log(res.data.active_dates);
  //         setEnabledDates(res.data.active_dates);
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // }, [state.serviceType, setEnabledDates]);

  // useEffect(() => {
  //   console.log(enabledDates, "current");
  // }, [enabledDates]);

  // const is_active_date = (date) => {
  //   for (let eDate of enabledDates) {
  //     if (eDate.date === date) {
  //       return true;
  //     }
  //   }
  //   return false;
  // };

  // const get_date_limit = (date) => {
  //   for (let eDate of enabledDates) {
  //     if (eDate.date === date) {
  //       return eDate.stock;
  //     }
  //   }
  //   return 0;
  // };

  return (
    <div className={`mnt-payment-form ${state.loading ? "loading" : ""}`}>
      {state.loading && <SpinLoader />}

      <h4>Select Service</h4>

      <div className="serviceOptions-container">
        <div
          className={`serviceOption ${
            state.serviceType === "express-slab" ? "selected" : ""
          }`}
          onClick={() => setServiceType("express-slab")}
        >
          <i class="x-icon-chevron-right" data-x-icon-s="&#xf054;"></i> EXPRESS
          SLAB SERVICE (3 Hours) : $75 / card
        </div>
        <div
          className={`serviceOption ${
            state.serviceType === "same-day-full" ? "selected" : ""
          }`}
          onClick={() => setServiceType("same-day-full")}
        >
          <i class="x-icon-chevron-right" data-x-icon-s="&#xf054;"></i> SAME DAY
          SLAB SERVICE : $50 / card
        </div>
        <div
          className={`serviceOption ${
            state.serviceType === "same-day-raw" ? "selected" : ""
          }`}
          onClick={() => setServiceType("same-day-raw")}
        >
          <i class="x-icon-chevron-right" data-x-icon-s="&#xf054;"></i> Raw Grading : $15 / card
        </div>
      </div>

      <h4>Select Expo Day</h4>
      <div className="serviceOptions-container">
        {state.EXPO_DATES &&
          state.EXPO_DATES.map((date) => (
            <div
              // className={`serviceOption ${
              //   state.serviceDay === date ? "selected" : ""
              // } ${is_active_date(date) ? "" : "inactive"}`}
              // onClick={() => is_active_date(date) && setServiceDays(date)}
              className={`serviceOption ${
                state.serviceDay === date ? "selected" : ""
              }`}
              onClick={() => setServiceDays(date)}
            >
              <i
                className="x-icon x-icon-clock-o"
                data-x-icon-o=""
                aria-hidden="true"
              ></i>{" "}
              {date}
            </div>
          ))}
      </div>

      {/* <h6 style={{ display: "none" }}>
        Pending Stock : {get_date_limit(state.serviceDay)}
      </h6> */}

      <h4>Card Details</h4>
      <CustomerInformationForm />

      <h6> Note: </h6>
      <ul>
      <li>EXPRESS SLAB SERVICE (3 HOURS) – <strong>Available Thursday - Sunday</strong> -  Cut off time for this service is 4 hours before the show closes that day. Please check availability prior to submitting for current timeframe. Limited quantities available.</li>
      <li>SAME DAY SLAB SERVICE – <strong>Available Thursday - Sunday.</strong> Submissions must be received by 12pm to guarantee same day service. Any submission received after 12pm will be guaranteed for the following day. Submissions can be picked up during the final hour of the show on the day it is to be completed. Limited quantities available.</li>
      <li>RAW GRADING* – <strong>Available Thursday - Sunday.</strong> Submissions must be received at least 2 hours before the end of the show for it to be returned the same day. Larger orders may be subject to delays depending on the time of submission.</li>
	  </ul>
    </div>
  );
}

export default App;
